import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('TimeframePaginator', (() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
})));

const TimeframePaginator = ({
  onNext,
  nextDisabled,
  onPrevious,
  previousDisabled,
}) => {
  const classes = useStyles();

  const PAGINATION_ITEMS = [
    {
      title: 'Previous 12 months',
      icon: ChevronLeftIcon,
      disabled: previousDisabled,
      onClick: onPrevious,
      test: 'previous-12-months-timeframe-button',
    },
    {
      title: 'Next 12 months',
      icon: ChevronRightIcon,
      disabled: nextDisabled,
      onClick: onNext,
      test: 'next-12-months-timeframe-button',
    },
  ];

  return (
    <Box
      className={classes.root}
    >
      {PAGINATION_ITEMS.map(paginator => (
        <IconButton
          key={paginator.title}
          className={classes.button}
          size="small"
          {...paginator}
        />))}
    </Box>
  );
};


TimeframePaginator.defaultProps = {};

TimeframePaginator.propTypes = {
  onNext: PropTypes.func.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  onPrevious: PropTypes.func.isRequired,
  previousDisabled: PropTypes.bool.isRequired,
};

export default TimeframePaginator;
